import { useMutation } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { vendorRepository } from '@webapp/modules/vendor/data-access/repositories/VendorRepository'
import { VendorPaymentMethod } from '@webapp/modules/vendor/entities/VendorPaymentMethod'

interface CreateVendorPaymentMethodVariables {
  vendorId: number
  name: string
  /** Legacy PaymentTypes enum value (0 = Other, 1 = Check) */
  type: number
  currencyId: number
}

// Command only (CQS). NO cache invalidation here — a `modules/vendor` feature
// must not import `modules/accounts-payable` query configs (ADR-6). The
// created method flows back through the presenter's `onCreated` callback and
// the accounts-payable Feature Set invalidates its own `billFormData` config.
export const useMutateCreateVendorPaymentMethod = () => {
  const mutation = useMutation<
    VendorPaymentMethod,
    RepoError,
    CreateVendorPaymentMethodVariables
  >({
    mutationFn: async ({ vendorId, name, type, currencyId }) => {
      const created = await vendorRepository.createVendorPaymentMethod(
        vendorId,
        { name, type, currencyId }
      )

      return new VendorPaymentMethod(created)
    },
  })

  return {
    createVendorPaymentMethod: mutation.mutateAsync,
    isCreating: mutation.isLoading,
    error: mutation.error,
  }
}
